<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />

    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header">
          <div slot="header">
            <strong>Repositorio</strong>
          </div>

          <b-modal
            v-model="modalArchivo"
            title="Nuevo archivo"
            cancel-title="Cancelar"
            ok-title="Guardar"
            @ok="nuevo()"
          >
            <b-form-file v-model="file" class="mt-3" plain></b-form-file>
          </b-modal>
          <b-modal
            v-model="modal"
            title="Editar Nombre del Archivo"
            cancel-title="Cancelar"
            ok-title="Guardar"
            @ok="modificar()"
          >
            <b-form-input v-model="archivoEditar.nombre" placeholder="Nuevo nombre"></b-form-input>
          </b-modal>
          <b-modal
            v-model="confirmar"
            title="Eliminar"
            cancel-title="Cancelar"
            ok-title="Eliminar"
            @ok="eliminar()"
          >
            <label for="textarea-small">¿Esta seguro de eliminar el elemento?</label>
          </b-modal>

          <v-client-table
            :columns="repositorio.columns"
            :data="docsList"
            :options="repositorio.options"
          >
            <div slot="options" slot-scope="props">
              <b-dropdown id="ddown1" size="sm" variant="outline-primary" text="Opciones">
                <b-dropdown-item @click="descargar(props.row)">Descargar</b-dropdown-item>
                <b-dropdown-item @click="modal=true, retener(props.row)">Modificar</b-dropdown-item>
                <b-dropdown-item @click="confirmar=true, retener(props.row)">Eliminar</b-dropdown-item>
               
              </b-dropdown>
            </div>
          </v-client-table>

          <b-col>
            <b-progress v-if="!terminado" :value="progreso" :max="100" show-progress animated></b-progress>
          </b-col>
          <hr />

          <b-button size="sm" variant="primary" @click="modalArchivo=true">Nuevo archivo</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Loader from "../../../views/Loader";
import SubeDoc from "../../../views/transparencia/normatividad/SubeDoc";
import axios from "axios";
import { mapGetters } from "vuex";
const date = require("date-and-time");
date.locale("es");

export default {
  name: "Repositorio",
  components: { Loader, SubeDoc },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role",
      "tableProps"
    ]),
    docsList() {
      let lista = [];

      this.repositorio.documentos.forEach(element => {
        var i = Math.floor(Math.log(element.size) / Math.log(1024));
        let nom = element.nombre.split(".",1);
        let n =nom[0];
        let doc = {
          tipo: element.tipo,
          size:
            parseFloat((element.size / Math.pow(1024, i)).toFixed(2)) +
            " " +
            "MB",
          _id: element._id,
          nombre: n,
          path: element.path,
          __v: element.__v
        };
        lista.push(doc);
      });
      return lista;
    }
  },
  data() {
    return {
      confirmar: false,
      enviando: false,
      terminado: true,
      progreso: 0,
      nuevoNombre: "",
      file: [],
      repositorio: {
        documentos: [],
        columns: ["options", "nombre", "tipo", "size"],
        options: {
          headings: {
            options: "",
            nombre: "Descripcion",
            tipo: "Tipo",
            size: "Tamaño"
          },
          sortIcon: {},
          texts: {}
        }
      },
      modalArchivo: false,
      modal: false,
      archivoEditar: {}
    };
  },
  methods: {
    retener(archivo) {
     
      
      this.archivoEditar = archivo;
    },
    nuevo() {
      this.terminado = false;
      const files = new FormData();
      files.append("archivo", this.file);
      axios
        .post(this.httpURL + "/tesoreria/repositorio/documento", files, {
          headers: { token: this.sessionToken },
          onUploadProgress: e =>
            (this.progreso = Math.round((e.loaded * 100) / e.total))
        })
        .then(res => {
          this.progreso = 0;
          this.terminado = true;
          this.agregaDocumento(res.data.documento);

          if (res.status === 200) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje
            });
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje
            });
          }
        })
        .catch(err => {
          err;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "No se pudo establecer una conexión al servidor."
          });
        });
    },
    forzar(res, nombre, tipo) {

  
     var nc =nombre+'.'+tipo;

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
    

      link.setAttribute("download", nc); //nombre anexo descarga
      document.body.appendChild(link);
      link.click();
 
      this.enviando=false;
    },
    descargar(archivo) {
      this.enviando = true;
      axios({
        method: "get",
        url: this.httpURL + "/tesoreria/repositorio/documento/" + archivo._id,
        responseType: "arraybuffer",

        headers: { token: this.sessionToken }
      })
        .then(res => {
          this.forzar(res, archivo.nombre, archivo.tipo);

          if (res.statusText !== "OK") {
            this.enviando = false;
         
          } 
        })
        .catch(err => {
          err;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "No se pudo establecer una conexión al servidor."
          });
        });
    },
    modificar() {
      this.enviando = true;
      axios
        .put(
          this.httpURL +
            "/tesoreria/repositorio/documento/" +
            this.archivoEditar._id,
          { nombre: this.archivoEditar.nombre },
          {
            headers: { token: this.sessionToken }
          }
        )
        .then(res => {
          let index = this.repositorio.documentos.findIndex(
            x => x._id === this.archivoEditar._id
          );
          if (index !== -1) {
            this.repositorio.documentos[index].nombre = res.data.nombre;
          }

          if (res.status === 200) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje
            });
            this.enviando=false;
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje
            });
          }
        })
        .catch(err => {
          err;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "No se pudo establecer una conexión al servidor."
          });
        });
    },
    eliminar() {
      this.enviando=true;
      axios
        .delete(
          this.httpURL + "/tesoreria/repositorio/documento/" + this.archivoEditar._id,
          {
            headers: { token: this.sessionToken }
          }
        )
        .then(res => {
          let index = this.repositorio.documentos.findIndex(
            x => x._id === this.archivoEditar._id
          );
          if (index !== -1) {
            this.repositorio.documentos.splice(index, 1);
          }

          if (res.status === 200) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje
            });
            this.enviando=false;
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje
            });
               this.enviando=false;
          }
        })
        .catch(err => {
          err;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "No se pudo establecer una conexión al servidor."
          });
             this.enviando=false;
        });
    },
    agregaDocumento(documento) {
      this.repositorio.documentos.push(documento);
    }
  },
  created() {
     this.enviando = true;
    this.repositorio.options.texts = this.tableProps.tableTexts;
    this.repositorio.options.sortIcon = this.tableProps.sortIcon;
    axios
      .get(this.httpURL + "/tesoreria/repositorio", {
        headers: { token: this.sessionToken }
      })
      .then(res => {
        this.repositorio.documentos = res.data.documentos;
        
        
        this.$notify({
          group: "foo",
          type: "success",
          duration: 2500,
          speed: 1000,
          text: "Lista de archivos cargada correctamente"
        });
        this.enviando = false;
      })
      .catch(error => {
        if (error.response) {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: error.response.data.mensaje
          });
        } else if (error.request) {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo establecer una conexión al servidor."
          });
        }
        this.enviando = false;
      });
  }
};
</script>